/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/upload'
export default icon
